import { z } from 'zod';

export const AttachmentSchema = z.object({
  id: z.string(),
  name: z.string(),
  mime_type: z.string(),
  size_bytes: z.number().int(),
  sha256: z.string(),
  createdAt: z.string(),
});
export type Attachment = z.infer<typeof AttachmentSchema>;

export const UploadAttachmentResponseSchema = z.object({
  attachment: AttachmentSchema,
});
export type UploadAttachmentResponse = z.infer<typeof UploadAttachmentResponseSchema>;
